import { config } from '../../config';
import {
  setOrders,
  setQueryLoading,
} from '../../redux/sliceCreators/orderSlice';
import { AppDispatch } from '../../redux/store';
import { client } from '../http';

export const getOrders =
  (pageSize = 20) =>
  async (dispatch: AppDispatch) => {
    dispatch(setQueryLoading(true));
    try {
      const { data } = await client.get(
        `${config.endpoints.getOrders}?page_size=${pageSize}`,
      );
      dispatch(setOrders({ ...data, initialLoading: false }));
    } catch (error) {
      console.log('error getOrders', error);
    } finally {
      dispatch(setQueryLoading(false));
    }
  };
